<template>
  <div v-if="!!post">
    <div class="entry-heading">
      <div class="wrapper">
        <a :href="'/'+ lang +'/news'"
           class="entry-heading__back hidden-xs"
           tag="a"
           @click.prevent="goBack()">
          {{ trans.text.news.back }}
        </a>
        <div class="entry-heading__title">
          <h1>{{ getPostTitle }}</h1>
        </div>
        <div class="d-flex">
          <div class="entry-heading__descr" v-html="getPostDescription"></div>
          <yandex-share
            :services="['facebook', 'linkedin','telegram','whatsapp']"
            class="social-wrap"
            counter
          />
        </div>
      </div>
    </div>

    <div class="entry-body">
      <template v-for="section in sections">

        <div v-if="section.type === 'text' && section.style === 'main-text' && !!section.content"
             class="wrapper">
          <p class="mb-2x" v-html="getReplacedText(section.content)"></p>
        </div>

        <div v-if="section.type === 'text' && section.style === 'heading' && !!section.content" class="wrapper">
          <h3 v-html="getReplacedText(section.content)"></h3>
        </div>

        <div v-if="section.type === 'text' && section.style === 'green-descriptor' && !!section.content"
             class="wrapper">
          <h3 class="tac green" style="color: #c2e900!important;"
              v-html="getReplacedText(section.content)"></h3>
        </div>

        <div v-if="section.type === 'text' && section.style === 'grey-descriptor' && !!section.content"
             class="entry-body-wide">
          <div class="wrapper">
            <p v-html="getReplacedText(section.content)"></p>
          </div>
        </div>

        <div v-if="section.type === 'image' && section.images.length > 0" class="entry-gallery">
          <div v-if="section.images.length === 1" class="entry-gallery__list">
            <div v-for="image in section.images" class="entry-gallery__col">
              <img :alt="getPostTitle" :src="image"/>
            </div>
          </div>
          <div v-if="section.images.length > 1" class="entry-gallery__list">
            <div v-for="image in section.images" class="entry-gallery__col entry-gallery__col--half">
              <img :alt="getPostTitle" :src="image"/>
            </div>
          </div>
        </div>

        <div v-if="section.type === 'video' && !!section.video" class="entry-gallery">
          <player :options="{autoplay:false, volume: 0.5}"
                  :sources="[{src:section.video}]">
          </player>
        </div>
      </template>
      <div v-if="slug==='forestal-augmented-reality'" class="entry-gallery">
        <div class="entry-gallery__list">
          <div class="entry-gallery__col">
            <a :href="'/'+lang+'/ar.usdz'">
              <img v-if="lang==='en'" :alt="getPostTitle"
                   src="/static/assets/images/ar/EN.jpg"/>
              <img v-if="lang==='de'" :alt="getPostTitle"
                   src="/static/assets/images/ar/DE.jpg"/>
              <img v-if="lang==='fr'" :alt="getPostTitle"
                   src="/static/assets/images/ar/FR.jpg"/>
              <img v-if="lang==='es'" :alt="getPostTitle"
                   src="/static/assets/images/ar/ES.jpg"/>

            </a>
          </div>
        </div>
      </div>
      <div class="wrapper">
        <div class="d-flex text-right-des">
          <yandex-share
            :services="['facebook', 'linkedin','telegram','whatsapp']"
            class="social-wrap"
            counter
          />
        </div>
      </div>

    </div>

    <div v-if="similarNews.length > 0" class="entry-news">
      <div class="wrapper">
        <div class="entry-news__headline">
          <h5 style="cursor: pointer" @click="showAllNews()">{{ trans.text.news.more }}</h5>
        </div>
        <div class="news-list news-list--col4">

          <div v-for="post in similarNews" class="news-card__col">
            <a v-if="post.images.length>0" :href="getPostLink(post)" class="news-card__item">
              <div class="news-card__image">
                <img :src="getStorageLink(post.images[0].image)" alt=""/>
              </div>
              <div class="news-card__text">
                <h4>{{ getSimilarPostTitle(post) }}</h4>
                <p>{{ getSimilarPostDescription(post) }} </p>
              </div>
            </a>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import player from 'vue-video'
import YandexShare from '@cookieseater/vue-yandex-share';

export default {
  props: ['slug', 'lang', 'trans'],
  name: "PostComponent",
  components: {player, YandexShare},
  data() {
    return {
      post: null
    }
  },
  mounted() {
    this.loadPost(this.slug);
  },
  methods: {
    ...mapActions(['getPostBySlug', 'getPreviewBySlug']),
    showAllNews() {
      location.href = `/${this.lang}/news`;
    },
    getReplacedText(text) {
      if (!!text) {
        text = text.replace(/font-size:[^d;]+;/g, '')
        text = text.replace(/font-family:[^d;]+;/g, '')
        text = text.replace(/<p/g, '<span')
        text = text.replace(/p>/g, 'span>')
        text = text.replace(/style="[^"]+"/g, '')
      }
      // console.log(text)
      return text
      return !!text ? text.replace(/([^>])\n/g, '$1<br/>')
        .replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;') : '';
    },
    getStorageLink(path) {
      return this.storage + path;
    },
    loadPost(slug) {
      const urlParams = new URLSearchParams(window.location.search);

      let ctx = this;
      if (window.location.pathname.split('/')[2] === 'preview') {
        let token = urlParams.get('access_token');

        if (!token) {
          token = localStorage.getItem('access_token')
        }

        this.getPreviewBySlug({
          path: this.$path,
          slug: slug,
          token: token
        }).then(post => {
          ctx.post = post;
          localStorage.setItem('access_token', token)
        }).catch(e => {
          // alert(e);
        });
      } else {
        this.getPostBySlug({
          path: this.$path,
          slug: slug
        }).then(post => {
          ctx.post = post;
        }).catch(e => {
          // alert(e);
        });
      }
    },
    getPostLink(post) {
      if (!!post.slug) {
        return `/${this.lang}/post/${post.slug}`
      }
      return null;
    },
    getSimilarPostTitle(post) {
      if (post.title.length < 15) {
        return post.title;
      }
      return `${post.title.substring(0, 15)}..`;
    },
    getSimilarPostDescription(post) {
      return this.stripHtml(post.desc);
    },
    stripHtml(html) {
      let tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    },
    goBack() {
      if (document.referrer === "") {
        this.$router.push(`/${this.lang}/news`);
      } else {
        history.back()
      }
    }
  },
  computed: {
    ...mapGetters(['storage']),
    sections() {
      if (!!this.post) {
        let language = this.lang;
        return JSON.parse(this.post[language].full_desc);
      }
      return [];
    },
    similarNews() {
      let prefix;
      let language = this.lang;
      prefix = language + '_';
      if (language === 'en') {
        prefix = '';
      }
      if (this.post[`${prefix}similar_news`].length > 0) {
        return this.post[`${prefix}similar_news`]
      }
      return [];
    },
    getPostTitle() {
      let language = this.lang;
      return this.post[language].title;
    },
    getPostDescription() {
      let language = this.lang;
      return this.post[language].desc;
    },
  },
  watch: {
    slug: {
      handler: function (slug) {
        if (slug !== this.post.slug) {
          this.loadPost(slug);
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@media (max-width: 1299px) {
  .news-card__col {
    padding: 0 5px;
  }
}

@media (max-width: 1023px) and (min-width: 768px) {
  .news-card__col {
    width: 50%;

    .news-card__item {
      margin-left: auto;
      margin-right: auto;
    }
  }
}
</style>
